import React, { useContext, useEffect } from "react";
import { useViewport } from "@bookingcom/bui-react";
import { trackWithDefaultStage } from "@flights/et-universal";
import { RemoteFooter } from "../../remote";
import { STICKY_FOOTER_SPACER_ID } from "../../../constants";
import scrollToTop from "../../../utils/scrollToTop";
import styles from "./AppShell.desktop.module.css";
import { mcn } from "../../../utils/mergeClassnames";
import useIsPostBookingRoute from "../../../hooks/useIsPostBookingRoute";
import useFlyAnywhereRoute from "../FlyAnywhere/hooks/useFlyAnywhereRoute";
import { OutletContext } from "./Outlet";

type Props = {
  header?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  noMainWrapper?: boolean;
};

const AppShell: React.FunctionComponent<Props> = (props) => {
  const { header, children, noMainWrapper } = props;
  const { isSmall } = useViewport();
  const isPostBooking = useIsPostBookingRoute();
  const isFlyAnywhereRoute = useFlyAnywhereRoute();
  const { sheetContainer } = useContext(OutletContext);

  const isResponsiveFixesSm =
    !isPostBooking && isSmall && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);

  useEffect(scrollToTop, []);

  const content = (
    <div
      className={mcn(styles.content, props.className, isResponsiveFixesSm && styles.contentSmall)}
      style={{ ...props.style }}
    >
      {children}
    </div>
  );
  return (
    <div className={mcn(styles.root, isFlyAnywhereRoute && styles.flyAnywhere)}>
      {!!header && <div id="app-header">{header}</div>}
      {noMainWrapper ? (
        content
      ) : (
        <main role="main" id="basiclayout" key="app-shell">
          {content}
        </main>
      )}

      {/* This spacer will create space for a sticky footer, it receives its height from the useStickyFooterSpacerHeight hook */}
      <div id={STICKY_FOOTER_SPACER_ID} aria-hidden />
      <RemoteFooter />
      {sheetContainer}
    </div>
  );
};
export default AppShell;
